import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Grid from '@mui/material/Grid';
import { map } from 'lodash';
import HeaderDropdown from "./header-dropdown";
import { useTranslation } from 'react-i18next';

const HeaderMenuItems = [
  {
    label: 'OECD.org',
    link: 'http://www.oecd.org/',
    uiKey: 'oecd',
  },
  {
    label: 'Data',
    link: 'http://data.oecd.org/',
    uiKey: 'data',
  },
  {
    label: 'Publications',
    link: 'https://www.oecd-ilibrary.org/',
    uiKey: 'publications',
  },
  {
    label: 'OECD Legal Instruments',
    link: '#',
    uiKey: 'legalInstruments',
  },
  {
    label: 'More sites',
    link: '#',
    uiKey: 'moreSites',
    subMenu: [
      {
        label: 'OECD Better Life Index',
        link: 'http://www.oecdbetterlifeindex.org/',
        uiKey: 'betterLifeIndex',
      },
      {
        label: 'OECD iLibrary',
        link: 'http://www.oecd-ilibrary.org/',
        uiKey: 'iLibrary',
      },
      {
        label: 'OECD Observer',
        link: 'http://www.oecdobserver.org/',
        uiKey: 'observer',
      },
      {
        label: 'OECD Insights blog',
        link: 'http://oecdinsights.org/',
        uiKey: 'InsightsBlog',
      },
      {
        label: 'OECD Development Centre',
        link: 'http://www.oecd.org/dev/',
        uiKey: 'developmentCentre',
      },
      {
        label: 'NEA Nuclear Energy Agency',
        link: 'http://www.oecd-nea.org/',
        uiKey: 'nuclearEnergyAgency',
      },
      {
        label: 'IEA International Energy Agency',
        link: 'http://www.iea.org/',
        uiKey: 'internationalEnergyAgency',
      },
      {
        label: 'SWAC Sahel and West Africa Club',
        link: "http://www.oecd.org/swac/",
        uiKey: 'sahelAndWestAfricaClub',
      },
      {
        label: 'FATF Financial Action Task Force',
        link: 'http://www.fatf-gafi.org/',
        uiKey: 'financialActionTaskForce',
      },
      {
        label: 'ITF International Transport Forum',
        link: 'http://www.itf-oecd.org/',
        uiKey: 'internationalTransportForum',
      }
    ]
  },
  {
    label: 'News',
    link: 'http://www.oecd.org/newsroom/',
    uiKey: 'news',
  },
  {
    label: 'Job vacancies',
    link: 'http://www.oecd.org/careers/',
    uiKey: 'jobs',
  }
];

const menuItemLinkStyle = {
  color: '#1a2126',
  textDecoration: 'none',
}

const legInstrumentStyle = {
  ...menuItemLinkStyle,
  fontWeight: 'bold',
};

const Header = () => {
  const { t } = useTranslation();

  return (
    <AppBar
      position="static"
      className={'hidePrint'}
      color="transparent"
      sx={{
        backgroundColor: '#fff',
      }}>
      <Toolbar
        variant="dense"
        sx={{
          pr: '24px', // keep right padding when drawer closed
        }}
      >
        <Grid container justifyContent="center" spacing={3}>
          {map(HeaderMenuItems, item => {
            const linkStyle = item.uiKey === 'legalInstruments' ? legInstrumentStyle : menuItemLinkStyle;
            return (
              <Grid item key={item.uiKey}>
                {item.subMenu ? <HeaderDropdown menuItem={item}/> :
                  <a href={item.link} style={linkStyle} target="_blank">
                    {t(item.label)}
                  </a>}
              </Grid>
            )
          })}
        </Grid>
      </Toolbar>
    </AppBar>
  )
};

export default Header;
